<template>
  <div class="case-detail-gene-clinvar-dailog dialog col-block">
    <div class="title-container row-block">
      <div class="title">{{ 'Variant Databases'/* ___ */ }}</div>
      <div :style="{ flex: 1 }"></div>
    </div>
    <div :style="{ height: '20px' }"></div>
    <div class="data-container col-block width-full" v-for="(variant, vindex) in variants" :key="vindex">
      <div class="data-title-container row-block">
        <div class="data-title">{{ variant.transcripts[variant.Feature] ? variant.transcripts[variant.Feature].HGVSc && !variant.transcripts[variant.Feature].HGVSc.includes(':') ? !variant.CHROM.startsWith('chrM') && !variant.Feature ? variant.transcripts[variant.Feature].HGVSc : variant.Feature + ':' + variant.transcripts[variant.Feature].HGVSc : variant.transcripts[variant.Feature].HGVSc : '- -' }}</div>
        <div :style="{ flex: 1 }"></div>
      </div>
      <div :style="{ height: '10px' }"></div>
      <div class="data-content-container col-block width-full">
        <div class="data-content-block col-block width-full" v-for="(optionGroup, gindex) in tableOptionGroups" :key="gindex">
          <div class="data-content-title-container row-block">
            <div class="data-content-title">{{ optionGroup.title }}</div>
            <div :style="{ width: '10px' }"></div>
            <a v-if="optionGroup.link && optionGroup.link(variant)" :href="optionGroup.link(variant)" target="_blank">
              <img :src="require('../../assets/images/external-link-icon.svg')" alt="">
            </a>
            <div :style="{ flex: 1 }"></div>
          </div>
          <div :style="{ height: '10px' }"></div>
          <div class="data-row-container col-block width-full">
            <div class="data-row row-block stretch">
              <div class="data-col col-block" v-for="(option, oindex) in optionGroup.options" :key="oindex" :class="[option.position]" :style="option.width ? { width: option.width } : { flex: 1 }">
                <div :style="{ flex: 1 }"></div>
                <div class="data-content" v-html="option.title"></div>
                <div :style="{ flex: 1 }"></div>
              </div>
            </div>
            <div class="data-row row-block stretch">
              <div class="data-col col-block" v-for="(option, oindex) in optionGroup.options" :key="oindex" :class="[option.position]" :style="option.width ? { width: option.width } : { flex: 1 }">
                <div :style="{ flex: 1 }"></div>
                <div class="data-content" :style="option.color ? { color: option.color(variant) } : {}" v-html="option.value(variant) || option.empty || '- -'"></div>
                <div :style="{ flex: 1 }"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="clinvar-statistic-container col-block width-full">
      <div class="clinvar-statistic-title-container row-block">
        <div class="clinvar-statistic-title">{{ 'ClinVar gene statistics'/* ___ */ }}</div>
        <div :style="{ flex: 1 }"></div>
      </div>
      <div :style="{ height: '10px' }"></div>
      <clinvarStatisticTable
        :defaultData="clinvarStatistic"
      ></clinvarStatisticTable>
    </div>
    <div :style="{ height: 0 }"></div>
    <div class="button-container row-block">
      <div :style="{ flex: 1 }"></div>
      <button class="gray-button circle-button" @click="e => $emit('changeModal')">
        <span>{{ 'Return'/* ___ */ }}</span>
      </button>
      <div :style="{ flex: 1 }"></div>
    </div>
  </div>
</template>

<script>
import clinvarStatisticTable from '../case/clinvarStatisticTable.vue'
import { getClinvarACMGMapDatas } from '../../constants/global/data'

export default {
  components: {
    clinvarStatisticTable
  },
  props: {
    param: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    gene () {
      return this.param.gene
    },
    variants () {
      return this.param.variants
    },
    clinvarStatistic () {
      return this.param.clinvarStatistic
    },
    // static
    tableOptionGroups () {
      const clinvar = {
        title: 'ClinVar'/* ___ */,
        link: variant => variant.ClinVar_URL,
        options: [
          {
            title: 'Interpretation'/* ___ */,
            value: variant => getClinvarACMGMapDatas(variant.CLIN_SIG).map(data => '<span' + (data.display === 'N/A' ? '' : ' style="color:' + data.color + ';"') + '>' + data.display + '</span>').join(',<br>'),
            color: null,
            width: '200px',
            position: 'center',
            empty: 'N/A'/* ___ */
          },
          {
            title: 'Review status'/* ___ */,
            value: variant => variant.ClinVar_CLNREVSTAT ? variant.ClinVar_CLNREVSTAT.split(',').map(value => value.replace(/_/g, ' ')).join(',<br>') : null,
            color: null,
            width: '250px',
            position: 'left',
            empty: 'N/A'/* ___ */
          },
          {
            title: 'Condition'/* ___ */,
            value: variant => variant.ClinVar_Disease_Name ? variant.ClinVar_Disease_Name.split('|').map(value => value.replace(/_/g, ' ')).join(',<br>') : null,
            color: null,
            width: null,
            position: 'left',
            empty: 'N/A'/* ___ */
          },
          {
            title: 'Conflicts'/* ___ */,
            value: variant => variant.CLIN_CONF ? variant.CLIN_CONF.split(',').map(value => value.replace(/_/g, ' ')).join(',<br>') : null,
            color: null,
            width: null,
            position: 'left',
            empty: 'N/A'/* ___ */
          }
        ]
      }
      const mitomap = (this.gene.SYMBOL || '').startsWith('MT-') ? {
        title: 'MITOMAP'/* ___ */,
        options: [
          {
            title: 'AF'/* ___ */,
            value: variant => variant.mitomap_AF,
            color: null,
            width: '70px',
            position: 'center',
            empty: 'N/A'/* ___ */
          },
          {
            title: 'Heteroplasmy'/* ___ */,
            value: variant => variant.mitomap_heteroplasmy,
            color: null,
            width: '130px',
            position: 'center',
            empty: 'N/A'/* ___ */
          },
          {
            title: 'Homoplasmy'/* ___ */,
            value: variant => variant.mitomap_homoplasmy,
            color: null,
            width: '130px',
            position: 'center',
            empty: 'N/A'/* ___ */
          },
          {
            title: 'Disease Status'/* ___ */,
            value: variant => variant.mitomap_DiseaseStatus,
            color: null,
            width: '250px',
            position: 'center',
            empty: 'N/A'/* ___ */
          },
          {
            title: 'Disease'/* ___ */,
            value: variant => variant.mitomap_Disease ? variant.mitomap_Disease.split('-/-').join(',<br>') : null,
            color: null,
            position: 'left',
            empty: 'N/A'/* ___ */
          },
          {
            title: 'Pubmed IDs'/* ___ */,
            value: variant => variant.mitomap_PubmedIDs ? variant.mitomap_PubmedIDs.split(',').join(',<br>') : null,
            color: null,
            width: '120px',
            position: 'center',
            empty: 'N/A'/* ___ */
          }
        ]
      } : null
      return [
        clinvar,
        mitomap
      ].filter(x => x)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/dialog/caseDetailGeneClinvar.vue